
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_adjust: false,
            modal_tranfer: false,


            loading: false,
            data: null,

            member_id: "",
            full_name: "",

            page: 1,
            data_search: "",
            member_id: ""
        }
    }
    async componentDidMount() {
        await this.Get();
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            member_id: ""
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result)
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    DeleteCustomer = async () => {
        this.Get();
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/member-info/delete/" + this.state.member_id, null);
        if (result && result.status) {
            success_url("/master/list-customer");
        }
        this.setState({ loading: false });
    }
    clear_form = () => {
        this.setState({
            modal_delete: false,
            modal_adjust: false,
            modal_tranfer: false,

            loading: false,

            member_id: "",
            full_name: ""
        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="ข้อมูลลูกค้า"/>
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>ข้อมูลลูกค้า</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                                <button className="btn btn-orange mx-1" onClick={() => { window.location.href = "/master/customer/create" }}>
                                    เพิ่มข้อมูลลูกค้า
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1, user_id: "" });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, user_id: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, data_search: "", user_id: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">รหัสลูกค้า</th>
                                            <th className="text-left text-white">ชื่อลูกค้า/ชื่อบริษัท</th>
                                            <th className="text-center text-white">เบอร์โทร</th>
                                            <th className="text-left text-white">E-mail</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.member_code ? item.member_code : "-"}</td>
                                                <td className="text-left">{item.full_name ? item.full_name : item.company_name}</td>
                                                <td className="text-center">{item.phone_number ? item.phone_number : "-"}</td>
                                                <td className="text-left">{item.email ? item.email : "-"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">

                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { window.location.href = "/master/customer/update?id=" + item.member_id }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                        </div>
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { window.location.href = "/manage-repair/list-repair?member_code=" + item.member_code + "&member_name=" + (item.full_name ? item.full_name : item.company_name) }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf7d9"}</label>
                                                        </div>
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { this.setState({ modal_delete: true, member_id: item.member_id, full_name: item.full_name ? item.full_name : item.company_name }) }}>
                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบข้อมูลลูกค้า</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบข้อมูลลูกค้า “{this.state.full_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.DeleteCustomer() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
